import weatherQuery from './weather-query';

export default weatherQuery;